module.exports = {
  localeName: 'el-GR',
  momentFormat: 'DD/MM/YYYY',
};
